import { useState, useEffect, useRef, useCallback } from 'react'
import { supabase } from './supabase'
import Navbar from './components/Navbar'
import Dashboard from './pages/Dashboard'
import Alerta from './pages/Switch'
import Login from './pages/Login'
import Registro from './pages/Registro'
import Legado from './pages/Legado'
import PoliticaPrivacidad from './pages/PoliticaPrivacidad'
import Terminos from './pages/Terminos'
import AvisoLegal from './pages/AvisoLegal'
import Blog from './pages/Blog'
import BannerCookies from './components/BannerCookies'
import FooterLegal from './components/FooterLegal'
import Mensajes from './pages/Mensajes'
import MiPerfil from './pages/MiPerfil'
import Seguridad from './pages/Seguridad'
import SiAlgoPasa from './pages/SiAlgoPasa'
import Instrucciones from './pages/Instrucciones'
import Emergencia from './pages/Emergencia'
import ResetPassword from './pages/ResetPassword'

function ResetPasswordInline({ onDone }) {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [verPass, setVerPass] = useState(false)
  const [verConfirm, setVerConfirm] = useState(false)
  const [error, setError] = useState('')
  const [listo, setListo] = useState(false)
  const [cargando, setCargando] = useState(false)

  const requisitos = {
    largo: password.length >= 8,
    mayuscula: /[A-Z]/.test(password),
    numero: /[0-9]/.test(password),
    simbolo: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password),
  }
  const passwordOk = Object.values(requisitos).every(Boolean)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!passwordOk) { setError('La contraseña no cumple los requisitos.'); return }
    if (password !== confirm) { setError('Las contraseñas no coinciden.'); return }
    setCargando(true)

    const accessToken = sessionStorage.getItem('recovery_access_token')
    const refreshToken = sessionStorage.getItem('recovery_refresh_token')
    if (accessToken) {
      await supabase.auth.setSession({ access_token: accessToken, refresh_token: refreshToken })
    }

    const { error } = await supabase.auth.updateUser({ password })
    if (error) { setError(error.message); setCargando(false); return }
    sessionStorage.removeItem('recovery_access_token')
    sessionStorage.removeItem('recovery_refresh_token')
    sessionStorage.removeItem('etern_recovery')
    setListo(true)
    setTimeout(() => onDone(), 2000)
  }

  if (listo) return <p style={{ color: '#5C6B3A', textAlign: 'center', fontWeight: '600' }}>✓ Contraseña actualizada. Redirigiendo...</p>

  return (
    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
      <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#2C1810', textAlign: 'center', marginBottom: '8px' }}>Nueva contraseña</h2>
      {error && <div style={{ backgroundColor: '#FDF0EC', color: '#8B2E0F', padding: '10px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px', border: '1px solid #F5C9B8' }}>{error}</div>}

      <div style={{ marginBottom: '8px' }}>
        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2C1810', marginBottom: '4px' }}>Nueva contraseña</label>
        <div style={{ position: 'relative' }}>
          <input type={verPass ? 'text' : 'password'} value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ width: '100%', padding: '10px 40px 10px 12px', borderRadius: '8px', border: '1px solid #E8E0D5', fontSize: '14px', backgroundColor: '#FAF8F5', boxSizing: 'border-box' }}
            placeholder="Tu nueva contraseña" required />
          <button type="button" onClick={() => setVerPass(!verPass)}
            style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#8B6F47' }}>
            {verPass ? '🙈' : '👁️'}
          </button>
        </div>
      </div>

      <div style={{ fontSize: '12px', marginBottom: '12px', display: 'flex', flexDirection: 'column', gap: '3px' }}>
        {[
          { ok: requisitos.largo, texto: 'Mínimo 8 caracteres' },
          { ok: requisitos.mayuscula, texto: 'Al menos una mayúscula' },
          { ok: requisitos.numero, texto: 'Al menos un número' },
          { ok: requisitos.simbolo, texto: 'Al menos un símbolo (!@#$...)' },
        ].map((r, i) => (
          <span key={i} style={{ color: r.ok ? '#5C6B3A' : '#8B6F47' }}>
            {r.ok ? '✓' : '○'} {r.texto}
          </span>
        ))}
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#2C1810', marginBottom: '4px' }}>Confirmar contraseña</label>
        <div style={{ position: 'relative' }}>
          <input type={verConfirm ? 'text' : 'password'} value={confirm}
            onChange={e => setConfirm(e.target.value)}
            style={{ width: '100%', padding: '10px 40px 10px 12px', borderRadius: '8px', border: '1px solid #E8E0D5', fontSize: '14px', backgroundColor: '#FAF8F5', boxSizing: 'border-box' }}
            placeholder="Repite la contraseña" required />
          <button type="button" onClick={() => setVerConfirm(!verConfirm)}
            style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#8B6F47' }}>
            {verConfirm ? '🙈' : '👁️'}
          </button>
        </div>
      </div>

      <button type="submit" disabled={cargando || !passwordOk}
        style={{ width: '100%', padding: '12px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: passwordOk ? 'pointer' : 'not-allowed', opacity: (cargando || !passwordOk) ? 0.6 : 1 }}>
        {cargando ? 'Guardando...' : 'Guardar nueva contraseña'}
      </button>
    </form>
  )
}

function App() {
  const [sesion, setSesion] = useState(null)
  const [esRecovery, setEsRecovery] = useState(
    sessionStorage.getItem('etern_recovery') === 'true'
  )
  const [cargando, setCargando] = useState(true)
  const [esMobil, setEsMobil] = useState(window.innerWidth <= 768)
  useEffect(() => {
    const handler = () => setEsMobil(window.innerWidth <= 768)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])
  const [pagina, setPagina] = useState('login')
  const [paginaActiva, setPaginaActiva] = useState(localStorage.getItem('pagina_activa') || 'estado')
  const [abrirLogin, setAbrirLogin] = useState(false)
  const [timeoutConfig, setTimeoutConfig] = useState(localStorage.getItem("sesion_timeout") || "5min")
  const timerRef = useRef(null)

  const params = new URLSearchParams(window.location.search)
  const tokenLegado = params.get('token')
  const ruta = window.location.pathname
  const hashParams = new URLSearchParams(window.location.hash.replace('#', ''))
  const esRecoveryHash = hashParams.get('type') === 'recovery'
  const vieneDeLogin = params.get('login') === '1'
  const vieneDeRegistro = params.get('registro') === '1'

  const handleLogout = useCallback(async () => {
    await supabase.auth.signOut()
    setSesion(null)
    window.scrollTo({ top: 0 })
  }, [])

  useEffect(() => {
    if (!sesion) return
    if (esRecovery || esRecoveryHash) return
    const tiempoGuardado = timeoutConfig
    const tiempos = { inmediato: 0, '5min': 5 * 60 * 1000, '10min': 10 * 60 * 1000 }
    const tiempo = tiempos[tiempoGuardado]

    function resetTimer() {
      if (timerRef.current) clearTimeout(timerRef.current)
      if (tiempo > 0) timerRef.current = setTimeout(() => handleLogout(), tiempo)
    }

    function handleVisibilityChange() {
      if (document.hidden) {
        if (tiempo > 0) {
          timerRef.current = setTimeout(() => handleLogout(), tiempo)
        } else {
          handleLogout()
        }
      } else {
        if (timerRef.current) clearTimeout(timerRef.current)
      }
    }

    const eventos = ['mousedown', 'keydown', 'touchstart', 'scroll']
    eventos.forEach(e => window.addEventListener(e, resetTimer))
    document.addEventListener('visibilitychange', handleVisibilityChange)
    if (tiempo > 0) resetTimer()

    return () => {
      eventos.forEach(e => window.removeEventListener(e, resetTimer))
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [sesion, esRecovery, handleLogout, timeoutConfig])

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSesion(session)
      setCargando(false)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        if (_event === 'PASSWORD_RECOVERY') {
          if (session?.access_token) {
            sessionStorage.setItem('recovery_access_token', session.access_token)
            sessionStorage.setItem('recovery_refresh_token', session.refresh_token)
          }
          setEsRecovery(true)
          setSesion(session)
          return
        }
        if (_event === 'SIGNED_OUT') {
          setSesion(null)
          setEsRecovery(false)
          return
        }
        if (_event === 'SIGNED_IN') {
          supabase.auth.mfa.getAuthenticatorAssuranceLevel().then(({ data }) => {
            if (data?.nextLevel === 'aal2' && data?.nextLevel !== data?.currentLevel) {
              return
            }
            setSesion(session)
          })
          return
        }
        setSesion(session)
      }
    )
    return () => subscription.unsubscribe()
  }, [])

  function irAPagina(nuevaPagina, nuevoAbrirLogin = false) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setAbrirLogin(nuevoAbrirLogin)
    setPagina(nuevaPagina)
  }

  function cambiarPaginaActiva(nueva) {
    localStorage.setItem('pagina_activa', nueva)
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setPaginaActiva(nueva)
  }

  if (ruta === '/blog') return <Blog onIrALogin={() => irAPagina('login', true)} onIrARegistro={() => irAPagina('registro', false)} onIrAInicio={() => irAPagina('login', false)} />
  if (ruta === '/privacidad') return <><PoliticaPrivacidad /><BannerCookies /></>
  if (ruta === '/terminos') return <><Terminos /><BannerCookies /></>
  if (ruta === '/aviso-legal') return <><AvisoLegal /><BannerCookies /></>
  if (tokenLegado) return <Legado />
  if (ruta === '/reset-password') return <ResetPassword />

  const rutaEmergencia = ruta === '/emergencia'
  if (rutaEmergencia) return <Emergencia />

  if (cargando) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Cargando...</p>
      </div>
    )
  }

  if (!sesion) {
    if (pagina === 'registro' || vieneDeRegistro) {
      return (
        <>
          <Registro
            onRegistroExitoso={() => irAPagina('login', true)}
            onIrALogin={() => irAPagina('login', true)}
            onIrAInicio={() => irAPagina('login', false)}
          />
          <BannerCookies />
        </>
      )
    }
    return (
      <>
        <Login
          abrirLogin={abrirLogin || vieneDeLogin}
          onLoginExitoso={() => {
            supabase.auth.getSession().then(({ data: { session } }) => setSesion(session))
          }}
          onIrARegistro={() => irAPagina('registro', false)}
        />
        <BannerCookies />
      </>
    )
  }

const esDashboard = ['estado', 'miscuentas', 'mispersonas'].includes(paginaActiva)

  if (esRecovery) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#FAF8F5',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div style={{ backgroundColor: '#FFFFFF', borderRadius: '16px',
        padding: '40px', width: '100%', maxWidth: '420px', border: '1px solid #E8E0D5',
        display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src="/logo-circulo.png" alt="ETERN-ME"
          style={{ width: '80px', height: '80px', borderRadius: '50%', marginBottom: '16px' }} />
        <ResetPasswordInline onDone={() => { setEsRecovery(false); handleLogout() }} />
      </div>
    </div>
  )

  return (
  <div style={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
    <Navbar
      onLogout={handleLogout}
      usuario={sesion.user.email}
      paginaActiva={paginaActiva}
      onCambiarPagina={cambiarPaginaActiva}
    />
    <div className="contenido-principal" style={{ flex: 1, minWidth: 0, overflowX: 'hidden', paddingTop: esMobil ? '64px' : '0' }}>
      <div className="topbar-spacer" />
      {esDashboard && (
        <Dashboard
          userId={sesion.user.id}
          paginaActiva={paginaActiva}
          onCambiarPagina={cambiarPaginaActiva}
          onIrASwitch={() => cambiarPaginaActiva('alerta')}
          onIrAMensajes={() => cambiarPaginaActiva('cartas')}
          onIrAPerfil={() => cambiarPaginaActiva('miperfil')}
        />
      )}
      {paginaActiva === 'cartas' && <Mensajes userId={sesion.user.id} tipo="cartas" />}
      {paginaActiva === 'mihistoria' && <Mensajes userId={sesion.user.id} tipo="mihistoria" />}
      {paginaActiva === 'miperfil' && <MiPerfil userId={sesion.user.id} />}
      {paginaActiva === 'alerta' && <Alerta userId={sesion.user.id} userEmail={sesion.user.email} />}
      {paginaActiva === 'instrucciones' && <Instrucciones userId={sesion.user.id} onCambiarPagina={cambiarPaginaActiva} />}
      {paginaActiva === 'seguridad' && <Seguridad userId={sesion.user.id} onTimeoutChange={setTimeoutConfig} />}
      {paginaActiva === 'reset-password' && <ResetPassword />}
      {paginaActiva === 'checklist' && <MiPerfil userId={sesion.user.id} pestanaInicial="checklist" />}
      {paginaActiva === 'sialgopasa' && <SiAlgoPasa userId={sesion.user.id} /> }
      {paginaActiva === 'mascotas' && (
        <Dashboard
          userId={sesion.user.id}
          paginaActiva="mascotas"
          onCambiarPagina={cambiarPaginaActiva}
          onIrASwitch={() => cambiarPaginaActiva('alerta')}
          onIrAMensajes={() => cambiarPaginaActiva('cartas')}
          onIrAPerfil={() => cambiarPaginaActiva('miperfil')}
        />
      )}
      <FooterLegal />
      <BannerCookies />
    </div>
  </div>
)
}

export default App